import { CultureInfo } from '../culture-info.model';
import { CultureInfoCcp } from './ccp';

/**
 * @ignore
 */
export const CultureInfoCcpBD: CultureInfo = {
  name: 'ccp-BD',
  displayName: '𑄌𑄋𑄴𑄟𑄳𑄦 (𑄝𑄁𑄣𑄘𑄬𑄌𑄴)',
  iso3LanguageCode: 'ccp',
  iso2LanguageCode: 'ccp',
  ietfLanguageTag: 'ccp-BD',
  parent: CultureInfoCcp
};
